import {
  errCodeMap,
} from '../lib/errors';
import fetch from '@/lib/fetch';

const codeMapPopType = {
  5320: 1,
  5307: 2,
  5321: 3,
};

export default {
  methods: {
    // 根据状态码，展示相应saas平台绑定弹层
    showBindSaasPop(code) {
      this.$store.commit('common/SHOW_BIND_SAAS_POP', {
        type: codeMapPopType[code],
      });
    },
    async bindJdPid(jdPid) {
      const reqPromise = fetch.post('v3/account/saas/bind', {
        saas_id: jdPid,
        saas_type: 'jd',
      });
      reqPromise.then((res) => {
        if (res.code !== 0) {
          const errMsg = errCodeMap[res.code] || res.message || `错误码：${res.code}，错误信息：${res.msg}`;

          this.$tip.error(errMsg);

          return;
        }

        this.$tip({
          message: '绑定京东平台成功',
          type: 'success',
        });
      })
        .catch((err) => {
          this.$tip.error(err.message || '绑定京东平台失败');
        });

      return reqPromise;
    },
  },
};
